import index from './konnGrid'

export default index